import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Space, Input, Row, Col } from 'antd';
import { LockOutlined } from '@ant-design/icons';

import { CommonFormProps, OnboardingLayout } from '.';
import { BackButton, Form } from '~/components';
import { login as loginQuery } from '~/api/auth';
import { auth } from '~/api/axios';
import { useOnboardingPage, useOnboardingState } from '~/hooks/onboarding';
import onError from '~/errorsHandler';
import { useIdentity } from '~/hooks/identity';

const { Title, Text } = Typography;

const AuthenticateWithPassword: FC<CommonFormProps> = (props) => {
  const { name } = props;
  const [isLoading, setLoading] = useState(false);

  const [, setPageState] = useOnboardingState(name);

  const onboardingPage = useOnboardingPage(name);
  const apiIdentityQuery = useIdentity();
  const email = apiIdentityQuery.data?.emailAddress;

  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    const { password } = values;
    if (!email) return;
    setLoading(true);
    try {
      const { headers } = await loginQuery(email, password);
      auth.deleteToken();
      auth.setToken(headers, 'password');

      setPageState((prev) => ({
        ...prev,
        disabled: true,
      }));
      onboardingPage.activateNext();
      onboardingPage.goNext();
    } catch (error: any) {
      onError(error);
    }
    setLoading(false);
  };

  return (
    <OnboardingLayout>
      <Title level={2}>{t('Authenticate with password')}</Title>
      <Space size="middle" direction="vertical">
        <Text>{t('Enter password for {{email}}', { email })}</Text>
        <Form form={form} layout="vertical" size="large" onFinish={onFinish}>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input.Password placeholder={t('Password')} prefix={<LockOutlined />} />
          </Form.Item>
          <Row gutter={16}>
            <Col>
              <BackButton onClick={onboardingPage.goBackToVisible} />
            </Col>
            <Col>
              <Form.Item noStyle>
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  {dt('continue')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    </OnboardingLayout>
  );
};

export default AuthenticateWithPassword;
